module.exports = __webpack_public_path__ + "img/1.f5399f5d.svg";